/**
* Scheme
*/
export default function () {
  return {
    main: {
      '@context': 'http://schema.org',
      '@type': 'LocalBusiness',
      name: 'CustomUSB',
      description: 'CustomUSB is a service oriented customized USB products designer, manufacturer, and distributor specializing in custom USB product development, and the creation of exact scale replicas of licensed products for retail sale.',
      logo: `${useRuntimeConfig().public.confGlobal.currentSiteUrl}/img/logo-slogan.svg`,
      image: `${useRuntimeConfig().public.confGlobal.currentSiteUrl}/img/logo.png`,
      telephone: ['+1-847-205-5200', '+1-800-447-0149'],
      faxNumber: '+1-847-556-0166',
      email: 'sales@customusb.com',
      url: useRuntimeConfig().public.confGlobal.currentSiteUrl,
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+1-847-205-5200',
          contactType: 'Customer Service',
          availableLanguage: 'English'
        }, {
          '@type': 'ContactPoint',
          telephone: '+1-800-447-0149',
          contactType: 'Customer Service',
          availableLanguage: 'English',
          contactOption: 'TollFree'
        }],
      address: {
        '@type': 'PostalAddress',
        streetAddress: '1360 Abbott Court',
        addressLocality: 'Buffalo Grove',
        addressRegion: 'IL',
        postalCode: '60089',
        addressCountry: 'USA'
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '42.1237417',
        longitude: '-87.9146022'
      },
      openingHours: ['Mo-Fri 08:00-18:30'],
      currenciesAccepted: 'USD',
      priceRange: '$1.89 - $300.00',
      sameAs: [
        'https://www.facebook.com/customusbdrives',
        'https://twitter.com/customusb'
      ],
      hasMap: 'https://www.google.com/maps/place/CustomUSB/@42.1237417,-87.9146022,15z/data=!4m5!3m4!1s0x0:0x3ff55c62fa0a3f3e!8m2!3d42.1237417!4d-87.9146022'
    }
  }
}
